import React from "react";
import { LIGHT_TEXT_COLOR } from "../styles";

const labelStyles = {
    color: LIGHT_TEXT_COLOR
};

export default (props) => (
    <label htmlFor={props.htmlFor} style={Object.assign({}, labelStyles, props.style)}>{props.children}</label>
)



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/Label.js
 **/